import { Card, Grid } from '@enterprise-ui/canvas-ui-react'

export const BulkHeader = () => {
  return (
    <Grid.Container>
      <Grid.Item xs={12} className="hc-pt-none hc-pl-min hc-pr-min">
        <Card className="hc-pa-expanded" corners="none" elevation="0">
          <h2 className="hc-fs-lg hc-lh-expanded font-color-default font-weight-500">
            Upload item data via spreadsheet
          </h2>
          <p className="hc-fs-sm hc-lh-expanded hc-mt-normal font-color-default font-weight-400">
            Upload data for multiple items at once using the item type specific
            pre-formatted template.
          </p>
        </Card>
      </Grid.Item>
    </Grid.Container>
  )
}
